import React from "react";
import styled from "styled-components";

const Loader = () => {
  return (
    <StyledWrapper>
      <div className="loader h-[60%] w-[60%] sm:h-[80%] sm:w-[80%] md:h-full md:w-full">
        <svg height={0} width={0} viewBox="0 0 100 100" className="absolute">
          <defs className="s-xJBuHA073rTt" xmlns="http://www.w3.org/2000/svg">
            <linearGradient
              className="s-xJBuHA073rTt"
              gradientUnits="userSpaceOnUse"
              y2={2}
              x2={0}
              y1={62}
              x1={0}
              id="b"
            >
              <stop className="s-xJBuHA073rTt" stopColor="#6263ED" />
              <stop
                className="s-xJBuHA073rTt"
                stopColor="#A7006F"
                offset="1.5"
              />
            </linearGradient>
            <linearGradient
              className="s-xJBuHA073rTt"
              gradientUnits="userSpaceOnUse"
              y2={0}
              x2={0}
              y1={64}
              x1={0}
              id="c"
            >
              <stop className="s-xJBuHA073rTt" stopColor="#6263ED" />
              <stop className="s-xJBuHA073rTt" stopColor="#A7006F" offset={1} />
              <animateTransform
                repeatCount="indefinite"
                keySplines=".42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1;.42,0,.58,1"
                keyTimes="0; 0.125; 0.25; 0.375; 0.5; 0.625; 0.75; 0.875; 1"
                dur="8s"
                values="0 32 32;-270 32 32;-270 32 32;-540 32 32;-540 32 32;-810 32 32;-810 32 32;-1080 32 32;-1080 32 32"
                type="rotate"
                attributeName="gradientTransform"
              />
            </linearGradient>
            <linearGradient
              className="s-xJBuHA073rTt"
              gradientUnits="userSpaceOnUse"
              y2={2}
              x2={0}
              y1={62}
              x1={0}
              id="d"
            >
              <stop className="s-xJBuHA073rTt" stopColor="#6263ED" />
              <stop
                className="s-xJBuHA073rTt"
                stopColor="#A7006F"
                offset="1.5"
              />
            </linearGradient>
          </defs>
        </svg>

        {/* First Y */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 100 100"
          width={100}
          height={100}
          className="inline-block"
        >
          <path
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth={8}
            stroke="url(#b)"
            d="M 20,20 L 50,50 L 80,20 M 50,50 L 50,80"
            className="dash"
            id="Y1"
            pathLength={360}
          />
        </svg>

        {/* First O - Gamepad */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 512 512"
          width={100}
          height={100}
          className="inline-block rotate"
        >
          <path
            stroke="url(#c)"
            strokeLinejoin="round"
            strokeLinecap="round"
            fill="none"
            strokeMiterlimit="10"
            strokeWidth="40"
            d="M467.51 248.83c-18.4-83.18-45.69-136.24-89.43-149.17A91.5 91.5 0 0 0 352 96c-26.89 0-48.11 16-96 16s-69.15-16-96-16a99.09 99.09 0 0 0-27.2 3.66C89 112.59 61.94 165.7 43.33 248.83c-19 84.91-15.56 152 21.58 164.88 26 9 49.25-9.61 71.27-37 25-31.2 55.79-40.8 119.82-40.8s93.62 9.6 118.66 40.8c22 27.41 46.11 45.79 71.42 37.16 41.02-14.01 40.44-79.13 21.43-165.04z"
            className="dash"
            pathLength={360}
          />
          <circle cx="292" cy="224" r="10" stroke="url(#c)" strokeWidth="20" fill="none" />
          <path d="M336 288a10 10 0 1 1 10-9.95A10 10 0 0 1 336 288z" stroke="url(#c)" strokeWidth="20" fill="none" />
          <circle cx="336" cy="180" r="10" stroke="url(#c)" strokeWidth="20" fill="none" />
          <circle cx="380" cy="224" r="10" stroke="url(#c)" strokeWidth="20" fill="none" />
          <path
            fill="none"
            stroke="url(#c)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="20"
            d="M160 176v96m48-48h-96"
          />
        </svg>

        {/* Second Y */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 100 100"
          width={100}
          height={100}
          className="inline-block"
        >
          <path
            strokeLinejoin="round"
            strokeLinecap="round"
            strokeWidth={8}
            stroke="url(#d)"
            d="M 20,20 L 50,50 L 80,20 M 50,50 L 50,80"
            className="dash"
            id="Y2"
            pathLength={360}
          />
        </svg>

        {/* Second O - Gamepad */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 512 512"
          width={100}
          height={100}
          className="inline-block rotate"
        >
          <path
            stroke="url(#c)"
            strokeLinejoin="round"
            strokeLinecap="round"
            fill="none"
            strokeMiterlimit="10"
            strokeWidth="40"
            d="M467.51 248.83c-18.4-83.18-45.69-136.24-89.43-149.17A91.5 91.5 0 0 0 352 96c-26.89 0-48.11 16-96 16s-69.15-16-96-16a99.09 99.09 0 0 0-27.2 3.66C89 112.59 61.94 165.7 43.33 248.83c-19 84.91-15.56 152 21.58 164.88 26 9 49.25-9.61 71.27-37 25-31.2 55.79-40.8 119.82-40.8s93.62 9.6 118.66 40.8c22 27.41 46.11 45.79 71.42 37.16 41.02-14.01 40.44-79.13 21.43-165.04z"
            className="dash"
            pathLength={360}
          />
          <circle cx="292" cy="224" r="10" stroke="url(#c)" strokeWidth="20" fill="none" />
          <path d="M336 288a10 10 0 1 1 10-9.95A10 10 0 0 1 336 288z" stroke="url(#c)" strokeWidth="20" fill="none" />
          <circle cx="336" cy="180" r="10" stroke="url(#c)" strokeWidth="20" fill="none" />
          <circle cx="380" cy="224" r="10" stroke="url(#c)" strokeWidth="20" fill="none" />
          <path
            fill="none"
            stroke="url(#c)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="20"
            d="M160 176v96m48-48h-96"
          />
        </svg>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .absolute {
    position: absolute;
  }

  .inline-block {
    display: inline-block;
  }

  .loader {
    display: flex;
    margin: 0.25em auto;
  }

  .w-2 {
    width: 0.5em;
  }

  .dash {
    animation: dashArray 2s ease-in-out infinite, dashOffset 2s linear infinite;
  }

  .rotate {
    animation: spin 10s ease-in-out infinite;
    transform-origin: center;
  }

  .spin {
    animation: spinDashArray 10s ease-in-out infinite,
      spin 2s ease-in-out infinite, dashOffset 2s linear infinite;
    transform-origin: center;
  }

  @keyframes dashArray {
    0% {
      stroke-dasharray: 0 1 359 0;
    }

    50% {
      stroke-dasharray: 0 359 1 0;
    }

    100% {
      stroke-dasharray: 359 1 0 0;
    }
  }

  @keyframes spinDashArray {
    0% {
      stroke-dasharray: 270 90;
    }

    50% {
      stroke-dasharray: 0 360;
    }

    100% {
      stroke-dasharray: 250 90;
    }
  }

  @keyframes dashOffset {
    0% {
      stroke-dashoffset: 385;
    }

    100% {
      stroke-dashoffset: 5;
    }
  }

  @keyframes spin {
    0% {
      rotate: 0deg;
    }

    12.5%,
    25% {
      rotate: 270deg;
    }

    37.5%,
    50% {
      rotate: 540deg;
    }

    62.5%,
    75% {
      rotate: 810deg;
    }

    87.5%,
    100% {
      rotate: 1080deg;
    }
  }
`;

export default Loader;
